import QueryTask from "@arcgis/core/tasks/QueryTask";
import Query from "@arcgis/core/rest/support/Query";
import IdentifyTask from "@arcgis/core/tasks/IdentifyTask";
// import IdentifyParameters from "@arcgis/core/tasks/support/IdentifyParameters";
import IdentifyParameters from "@arcgis/core/rest/support/IdentifyParameters";
export const queryMode = {
    Features: "Features",
    ObjectIds: "ObjectIds",
    FeatureCount: "FeatureCount"
};
export function queryTask(options) {
    let queryTask = new QueryTask({
        url: options.url
    });
    let query = new Query();
    if (options.geometry !== undefined) {
        query.geometry = options.geometry;
    }
    if (options.spatialRelationship !== undefined) {
        query.spatialRelationship = options.spatialRelationship;
    }
    if (options.num !== undefined) {
        query.num = options.num;
    }
    if (options.start !== undefined) {
        query.start = options.start;
    }
    query.returnDistinctValues = options.returnDistinctValues ? options.returnDistinctValues : false;
    query.returnGeometry = options.returnGeometry != null ? options.returnGeometry : true;
    query.objectIds = options.objectIds ? options.objectIds : [];
    query.outFields = options.outFields ? options.outFields : ["*"];
    query.where = options.where === "" || options.where == "undefined" ? "1=1" : options.where;
    query.orderByFields = options.orderByFields ? options.orderByFields : [];
    query.start = options.start === "" ? undefined : options.start;
    query.num = options.num === "" ? undefined : options.num;
    query.distance = options.distance == "" ? undefined : options.distance;
    query.units = options.units == "" ? undefined : options.units;
    switch (options.mode.toLowerCase()) {
        case queryMode.Features.toLowerCase():
            return queryTask.execute(query);
        case queryMode.ObjectIds.toLowerCase():
            return queryTask.executeForIds(query);
        case queryMode.FeatureCount.toLowerCase():
            return queryTask.executeForCount(query);
    }
}
export function IdentifyTaskAsync(options) {
    let identifyTask = new IdentifyTask({
        url: options.url
    });
    let params = new IdentifyParameters();
    params.tolerance = options.tolerance;
    params.layerIds = options.layerIds;
    params.layerOption = options.layerOption;
    params.width = options.mapView.width;
    params.height = options.mapView.height;
    params.geometry = options.geometry;
    params.mapExtent = options.mapView.extent;
    params.returnGeometry = options.returnGeometry;
    return identifyTask.execute(params);
}
